export type RouteMeta = {
  title: string;
  description?: string;
  robots: string;
};

const BASE_TITLE = "PodWise GPT";

const PUBLIC_META: Record<string, RouteMeta> = {
  "/": {
    title: `${BASE_TITLE} - Ask Your Podcast Anything`,
    description:
      "Ask questions about any podcast and get answers grounded in the episode, with timestamps and translation in any language.",
    robots: "index,follow",
  },
  "/pricing": {
    title: `${BASE_TITLE} Pricing - Plans for Podcast Q&A`,
    description:
      "See PodWise GPT pricing and pick a plan to chat with any podcast, get timestamped answers, and explore topics in any language.",
    robots: "index,follow",
  },
  "/faq": {
    title: `${BASE_TITLE} FAQ - Common Questions`,
    description: "Find answers about PodWise GPT features, languages, pricing, and how podcast Q&A works.",
    robots: "index,follow",
  },
  "/terms": {
    title: `${BASE_TITLE} Terms of Service`,
    description: "Read the terms of service for PodWise GPT, including usage, billing, and account policies.",
    robots: "index,follow",
  },
  "/privacy": {
    title: `${BASE_TITLE} Privacy Policy`,
    description: "Learn how PodWise GPT handles data, privacy, and security.",
    robots: "index,follow",
  },
};

const PRIVATE_PREFIXES = [
  "/login",
  "/auth",
  "/episodes",
  "/chat",
  "/profile",
  "/podcasts",
  "/try",
  "/billing",
  "/paywall",
  "/text",
];

const privateMeta: RouteMeta = {
  title: `${BASE_TITLE} - App`,
  robots: "noindex,nofollow",
};

const notFoundMeta: RouteMeta = {
  title: `Page Not Found - ${BASE_TITLE}`,
  robots: "noindex,nofollow",
};

export const resolveRouteMeta = (pathname: string): RouteMeta => {
  const meta = PUBLIC_META[pathname];
  if (meta) return meta;

  const isPrivate = PRIVATE_PREFIXES.some(
    prefix => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );

  if (isPrivate) return privateMeta;

  return notFoundMeta;
};
